import * as React from 'react';
import { connect } from 'react-redux';
import { withState, compose, lifecycle } from 'recompose';
import { State } from 'reducers';
import { Stream, CellIndex, UtcTime, DeviceId } from 'types';
import { getStreamPosition } from 'selectors/monitoringSelectors';

export type OwnProps = {
    cellIndex: CellIndex;
    stream: Stream | null;
    frame: string | null;
};

const style: React.CSSProperties = {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
};

const oneTransparentPixel = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGP6zwAAAgcBApocMXEAAAAASUVORK5CYII=';

const RawStillFrameView = ({ cellIndex, stream, frameClone }: Props) =>
    <img
        id={ `cell-${cellIndex}-still` }
        className="abs"
        style={ style }
        width={ stream ? stream.width : 1 }
        height={ stream ? stream.height : 1 }
        src={ frameClone ? `data:image/jpeg;base64,${frameClone}` : oneTransparentPixel }
    />
;

type StateProps = {
    streamPosition: UtcTime;
};
type RecomposeProps = {
    frameClone: string | null;
    deviceId: DeviceId | null;
};
type _RecomposeProps = RecomposeProps & {
    _setFrameClone: (frame: string | null) => void;
    _setDeviceId: (deviceId: DeviceId | null) => void;
};

type Props = StateProps & RecomposeProps & OwnProps;

const mapStateToProps = (state: State, ownProps: OwnProps) => ({
    streamPosition: getStreamPosition(state, ownProps),
});

export const StillFrameView = compose<Props, OwnProps>(
    // Clone the frame when this component is mounted... so that we will continue to display the cloned
    // frame as this component fades out (which happens after frame is set to null).
    withState('frameClone', '_setFrameClone', ({ frame }: OwnProps) => frame),
    withState('deviceId', '_setDeviceId', ({ stream }: OwnProps) => stream && stream.deviceId),
    connect<StateProps, {}, {}>(mapStateToProps),
    lifecycle<Props & _RecomposeProps, {}>({
        componentDidUpdate(prevProps) {
            // Update the image when the camera changes or the frame changes to something non-null.
            const { stream, frame, deviceId, _setFrameClone, _setDeviceId } = this.props;
            if (!stream) return;
            if (stream.deviceId !== deviceId || frame) {
                _setFrameClone(frame);

                // Note: It's possible to observe a device ID change while the frame is null...
                //       so only cache the device ID when we clone a valid frame.
                if (frame) {
                    _setDeviceId(stream.deviceId);
                }
            }
        },
    }),
)(RawStillFrameView);



// WEBPACK FOOTER //
// ./src/ui/pages/monitoring/mainPanel/StillFrameView.tsx